import { render, staticRenderFns } from "./article-drawer.vue?vue&type=template&id=6ecdec6e&scoped=true"
import script from "./article-drawer.vue?vue&type=script&lang=js"
export * from "./article-drawer.vue?vue&type=script&lang=js"
import style0 from "./article-drawer.vue?vue&type=style&index=0&id=6ecdec6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdec6e",
  null
  
)

export default component.exports